
/** TRX合约发起交易 */
export async function sendTransactionForTRX(params) {
  console.log('params', params);
  try {
    const { contract, fun, options, parameter, account } = params;
    const { transaction } =
      await window.tronWeb.transactionBuilder.triggerSmartContract(
        contract,
        fun,
        options,
        parameter,
        account
      );
    const signed = await window.tronWeb.trx.sign(transaction);
    const res = await window.tronWeb.trx.sendRawTransaction(signed);
    if (res.result) {
      console.log('hash', res.txid);
      return res.txid
    }
  } catch (error) {
    console.log(error);
  }
}

export function sendTransactionForEVM(params) {

}
